export default "__VITE_PUBLIC_ASSET__14d86e3c__"